
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[date]",
      function () {
        return require("private-next-pages/content/[date].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[date]"])
      });
    }
  